import { Routes, Route } from "react-router-dom";
import { ROUTE_STUDENT_MANAGEMENT,ROUTE_ADMIN_ROUND_RESULTS,ROUTE_TEACHER_MANAGEMENT,ROUTE_ASPIRANT_MANAGEMENT,ROUTE_ADMIN_QUIZ_HISTORY,ROUTE_ADMIN_LEADER_BOARD, ROUTE_SCHOOL_MANAGEMENT,ROUTE_ADMIN_ASYNC_QUIZ_ROOM, ROUTE_ADMIN_QUIZ_PLAY,ROUTE_LOGIN, ROUTE_ADMIN_LIVE_QUIZ,ROUTE_ADMIN_COMPETITIVE_EXAM, ROUTE_ADMIN_QUIZ } from "..";
import { Login } from "../../components/login";
import { StudentManagement } from "../../components/student-management";
import { TeacherManagement } from "../../components/teacher-management";
import { AspirantManagement } from "../../components/aspirant-management";
import { SchoolManagement } from "../../components/school-management";
import { AdminCompetitiveExam } from "../../components/admin-competitive-exam";
import { AdminQuiz } from "../../components/admin-quiz";
import { AdminLiveQuizRoom } from "../../components/admin-live-room";
import { AdminQuizPlay } from "../../components/admin-quiz-play";
import { AdminAsyncQuizRoom } from "../../components/admin-async-quiz-room";
import { AdminQuizHistory } from "../../components/admin-quiz-history";
import { AdminLeaderboard } from "../../components/admin-leader-board";
import { AdminRoundResult } from "../../components/admin-round-results";

export const AdminRoutes = () => (
  <Routes>
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_STUDENT_MANAGEMENT} element={<StudentManagement />} />
    <Route path={ROUTE_TEACHER_MANAGEMENT} element={<TeacherManagement />} />
    <Route path={ROUTE_ASPIRANT_MANAGEMENT} element={<AspirantManagement />} />
    <Route path={ROUTE_SCHOOL_MANAGEMENT} element={<SchoolManagement />} />
    <Route path={ROUTE_ADMIN_COMPETITIVE_EXAM} element={<AdminCompetitiveExam />} />
    <Route path={ROUTE_ADMIN_QUIZ} element={<AdminQuiz />} />
    <Route path={ROUTE_ADMIN_LIVE_QUIZ} element={<AdminLiveQuizRoom />} />
    <Route path={ROUTE_ADMIN_QUIZ_PLAY} element={<AdminQuizPlay />} />
    <Route path={ROUTE_ADMIN_ASYNC_QUIZ_ROOM} element={<AdminAsyncQuizRoom />} />
    <Route path={ROUTE_ADMIN_QUIZ_HISTORY} element={<AdminQuizHistory />} />
    <Route path={ROUTE_ADMIN_LEADER_BOARD} element={<AdminLeaderboard />} />
  </Routes>
);
    <Route path={ROUTE_ADMIN_ROUND_RESULTS} element={<AdminRoundResult />} />